/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
// Polyfill for padStart
if (!String.prototype.padStart) {
  String.prototype.padStart = function (targetLength: number, padString: string = ' ') {
    const str = this + ''
    const diff = targetLength - str.length
    if (diff > 0) {
      padString = padString || ' '
      return (
        Array(diff / padString.length + 1)
          .join(padString)
          .slice(0, diff) + str
      )
    }
    return str
  }
}

export function extendsEnum(...enums: any[]): any {
  const kvs: PropertyKey[] = []
  for (const e of enums) {
    for (const kv of Object.keys(e)) {
      if (kvs.indexOf(kv) >= 0) {
        // errorID(3659);
      } else {
        kvs.push(kv)
      }
    }
  }
  return Object.assign({}, ...enums)
}

// 从 Uint8Array 或 ArrayBuffer 转换为字符串
export function bytesToString(bytes: Uint8Array): string {
  // 如果传入的是 ArrayBuffer，先转为 Uint8Array
  if (bytes instanceof ArrayBuffer) {
    bytes = new Uint8Array(bytes)
  }

  const decoder = new TextDecoder() // 默认 'utf-8'
  return decoder.decode(bytes)
}

export function stringToBytes(str: string): Uint8Array {
  // 创建TextEncoder实例
  const encoder = new TextEncoder()
  // 编码字符串为Uint8Array
  return encoder.encode(str)
}

export function bytesToNumber(bytes: Uint8Array, littleEndian = true): number {
  const view = new DataView(bytes.buffer)
  return view.getUint32(0, littleEndian)
}

export function formatDate(date: Date, formatStr: string): string {
  const map: Record<string, string> = {
    YYYY: String(date.getFullYear()),
    MM: String(date.getMonth() + 1).padStart(2, '0'),
    DD: String(date.getDate()).padStart(2, '0'),
    HH: String(date.getHours()).padStart(2, '0'),
    mm: String(date.getMinutes()).padStart(2, '0'),
    ss: String(date.getSeconds()).padStart(2, '0'),
  }

  return formatStr.replace(/YYYY|MM|DD|HH|mm|ss/g, (matched) => map[matched])
}

export function isSameDay(timestamp1: number, timestamp2: number): boolean {
  const date1 = new Date(timestamp1)
  const date2 = new Date(timestamp2)

  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  )
}

// // 添加或更新 URL 的搜索参数
// export function urlAddOrUpdateUid(url: string, uid: number | string): string {
//     if (url == null || uid == "") {
//         return "";
//     }

//     // 注意：URLSearchParams 在 Android 上会报错 [ERROR]: JS: ReferenceError: URLSearchParams is not defined
//     // const [baseUrl, queryString] = url.split('?');
//     // const searchParams = new URLSearchParams(queryString);

//     // // 更新或添加 uid 参数
//     // searchParams.set('uid', uid.toString());
//     // let newUrl = baseUrl + '?' + searchParams.toString();

//     // 分割哈希部分
//     const hashIndex = url.indexOf('#');
//     let base = url;
//     let hash = '';

//     if (hashIndex !== -1) {
//         base = url.substring(0, hashIndex);
//         hash = url.substring(hashIndex);
//     }

//     // 添加参数
//     const separator = base.includes('?') ? '&' : '?';
//     let newUrl = base + separator + 'uid=' + encodeURIComponent(uid) + hash;
//     log(`urlAddOrUpdateUid newUrl = ${newUrl}`);
//     return newUrl;
// }

// 添加或更新 URL 的搜索参数
export function urlAddOrUpdateParams(
  url: string,
  params: Record<string, string | number | boolean>,
): string {
  if (url == null || params == null) {
    return ''
  }

  // 分割哈希部分
  const hashIndex = url.indexOf('#')
  let base = url
  let hash = ''

  if (hashIndex !== -1) {
    base = url.substring(0, hashIndex)
    hash = url.substring(hashIndex)
  }

  // 分离基础 URL 和查询字符串
  const [baseUrl, queryString] = base.split('?')
  const searchParams = new Map<string, string>()

  // 解析现有查询参数
  if (queryString) {
    queryString.split('&').forEach((pair) => {
      const [key, value] = pair.split('=')
      searchParams.set(key, value)
    })
  }

  // 添加/更新参数
  for (const [key, value] of Object.entries(params)) {
    searchParams.set(key, encodeURIComponent(String(value)))
  }

  // 构建新的查询字符串
  const newQueryString = Array.from(searchParams.entries())
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  let finalUrl = newQueryString ? `${baseUrl}?${newQueryString}` : baseUrl
  finalUrl = finalUrl + hash
  return finalUrl
}

// 把节点的包围盒转换成 web 的坐标
export function nodeBoxToWebRect(node: Node): Rect {
  const nodeUI = node.getComponent(UITransform)
  const btnSize = size(nodeUI.width, nodeUI.height)
  const frameSize = view.getFrameSize()
  // let frameSize = screen.windowSize
  log(
    `nodeBoxToWebRect view.getFrameSize() = ${view.getFrameSize()}, screen.windowSize = ${screen.windowSize}`,
  )

  const worldRect = nodeUI.getBoundingBoxToWorld()
  // let ratio: number = view.getDevicePixelRatio();
  const ratio: number = screen.devicePixelRatio
  log(
    `nodeBoxToWebRect view.getDevicePixelRatio() = ${view.getDevicePixelRatio()}, screen.devicePixelRatio = ${screen.devicePixelRatio}`,
  )
  const scaleX: number = view.getScaleX()
  const factor: number = scaleX / ratio
  const offsetX: number = 0
  const offsetY: number = 0

  const top: number = frameSize.height - (worldRect.y + worldRect.height) * factor - offsetY
  const left: number = worldRect.x * factor + offsetX
  const width: number = btnSize.width * factor
  const height: number = btnSize.height * factor

  return rect(left, top, width, height)
}

export function fakeClick(node: Node) {
  if (isValid(node, true)) {
    log('fakeClick node')
    const changedTouches: Touch[] = []

    const startEvent = new EventTouch(changedTouches, true, Node.EventType.TOUCH_START)
    startEvent.touch = new Touch(node.position.x, node.position.y)
    startEvent.currentTarget = node

    const endEvent = new EventTouch(changedTouches, true, Node.EventType.TOUCH_END)
    endEvent.touch = new Touch(node.position.x, node.position.y)
    endEvent.currentTarget = node

    // node.emit(Node.EventType.TOUCH_START, startEvent);
    // node.emit(Node.EventType.TOUCH_END, endEvent);
    node.dispatchEvent(startEvent)
    node.dispatchEvent(endEvent)
  }
}

/**
 * Mimic Cocos Creator's cc.Enum function.
 */
export function ccenum<T extends object>(obj: T): T {
  return obj
}

/**
 * Mimic Cocos Creator's EventTarget with on, off, and emit methods.
 */
export class SimpleEventEmitter {
  private listeners: Map<string, Array<{ callback: (...args: any[]) => void; target?: any }>> =
    new Map()

  on(event: string, callback: (...args: any[]) => void, target?: any) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, [])
    }
    this.listeners.get(event)!.push({ callback, target })
  }

  off(event: string, callback: (...args: any[]) => void, target?: any) {
    const eventListeners = this.listeners.get(event)
    if (!eventListeners) return

    const index = eventListeners.findIndex((l) => l.callback === callback && l.target === target)
    if (index !== -1) {
      eventListeners.splice(index, 1)
    }
  }

  emit(event: string, ...args: any[]) {
    const eventListeners = this.listeners.get(event)
    if (!eventListeners) return

    // Create a copy to avoid issues if listeners are added/removed during emission
    const listenersCopy = [...eventListeners]
    for (const listener of listenersCopy) {
      if (listener.target) {
        listener.callback.apply(listener.target, args)
      } else {
        listener.callback(...args)
      }
    }
  }

  // Aliases for compatibility with standard EventTarget
  addEventListener(event: string, callback: (...args: any[]) => void, target?: any) {
    this.on(event, callback, target)
  }

  removeEventListener(event: string, callback: (...args: any[]) => void, target?: any) {
    this.off(event, callback, target)
  }
}

export function log(...args: any[]) {
  console.log(...args)
}

export function error(...args: any[]) {
  console.error(...args)
}

// Assign to globalThis to match Cocos Creator behavior where these are globally accessible
;(globalThis as any).ccenum = ccenum
;(globalThis as any).log = log
;(globalThis as any).error = error
